
export interface ErrorMessage {
  message: string;
}

export class SDKError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'SDKError';
  }
}